import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/sel-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-7d9f7c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-header" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "select-wrap" }
const _hoisted_4 = {
  class: "select-value",
  "data-id": "1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"2rem"}
}, null, -1))
const _hoisted_6 = { class: "select-options" }
const _hoisted_7 = {
  class: "select-options-wrap ini-scroll",
  style: {"width":"100%"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "导航数据统计", -1))
const _hoisted_10 = { class: "right" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "day" }
const _hoisted_13 = { class: "weather" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "__loading-container" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"__loading\" data-v-7d9f7c0c><i class=\"drop\" style=\"--i:1;\" data-v-7d9f7c0c></i><i class=\"drop\" style=\"--i:2;\" data-v-7d9f7c0c></i><i class=\"drop\" style=\"--i:3;\" data-v-7d9f7c0c></i><i class=\"drop\" style=\"--i:4;\" data-v-7d9f7c0c></i><i class=\"drop\" style=\"--i:5;\" data-v-7d9f7c0c></i><i class=\"drop\" style=\"--i:6;\" data-v-7d9f7c0c></i><i class=\"drop\" style=\"--i:7;\" data-v-7d9f7c0c></i><i class=\"drop\" style=\"--i:8;\" data-v-7d9f7c0c></i></div>", 1)
const _hoisted_17 = [
  _hoisted_16
]

import { ref, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'
import Moment from '@/utils/Moment';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderCpn',
  setup(__props) {

let time: any = null
const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)
const currentTime = ref<{
  hour: string,
  day: string,
  week: string
}>()

const industrys = ref([
  {
    id: 1,
    name: '视频会议'
  },
  {
    id: 2,
    name: '语义引擎'
  },
])

const loading = ref(false)

const active = ref()
const activeName = ref()


const getData = (id: number) => {
  if (loading.value) {
    return
  }
  active.value = id
  loading.value = true
  activeName.value = industrys.value.filter(v => v.id == id)[0].name;
  homeDataStore.getHomeData(id).finally(() => {
    loading.value = false
  })
}

onMounted(() => {
  getData(industrys.value[0].id)
})

onMounted(() => {
  getCurrentDate()
})

onUnmounted(() => {
  clearInterval(time)

})




const getCurrentDate = () => {
  time = setInterval(() => {
    currentTime.value = Moment.getCurrentDate()
  }, 1000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(activeName.value), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industrys.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["select-option", { 'select-option-active' : active.value === item.id}]),
                key: item.id,
                onClick: ($event: any) => (getData(item.id))
              }, _toDisplayString(item.name), 11, _hoisted_8))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(currentTime.value?.hour), 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", null, _toDisplayString(currentTime.value?.day), 1),
        _createElementVNode("span", null, _toDisplayString(currentTime.value?.week), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", null, "天气：" + _toDisplayString(_unref(data)?.weatherData.label), 1),
        _createElementVNode("img", {
          class: "icon",
          src: _unref(data)?.weatherData.icon,
          alt: "icon"
        }, null, 8, _hoisted_14)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_15, _hoisted_17, 512), [
      [_vShow, loading.value]
    ])
  ]))
}
}

})